import { MockFactory } from '@tino-frontend/mocks'
import { TutorialListResponse } from '@types'

export const tutorialsAPIMock = new MockFactory<TutorialListResponse>({
  tutorials: ['tutorialKeyA_v1', 'tutorialKeyA_v2', 'tutorialKeyB_v1'],
})
